import React from "react";
import { Grid } from "@material-ui/core";
import AttributeInput from "../AttributeInput";

const AttributeGroup = ({
  attributes,
  maskSensitive,
  onChange,
  onUnitChange,
  listOptions,
  spacing = 4,
}) => {
  const handleChange = (id, value) => {
    if (onChange !== undefined && typeof onChange === "function") {
      onChange(id, value);
    }
  };

  const handleUnitChange = (id, value) => {
    if (onUnitChange !== undefined && typeof onUnitChange === "function") {
      onUnitChange(id, value);
    }
  };

  return (
    <Grid container spacing={spacing}>
      {attributes.map((attr, index) => {
        return (
          <Grid key={attr.id} item md={3}>
            <AttributeInput
              attr={attr}
              maskSensitive={maskSensitive}
              onChange={handleChange}
              onUnitChange={handleUnitChange}
              listOptions={
                (listOptions || {})[attr.list_id || attr.data_type] || []
              }
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default AttributeGroup;
